/// <amd-module name="typeahead/features/ShowEssOnFocusPersonalizedSuggestions" />

import {EssDataProvider, IEssResponse} from "typeahead/core/EssDataProvider";
import {IFocusSuggester} from "typeahead/core/IFocusSuggester";
import {IListItem} from "typeahead/core/IListItem";
import {ISuggesterResponse} from "typeahead/core/ISuggester";
import {abTest} from "typeahead/core/plugins/ExecutionHelper";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {SuggesterId} from "typeahead/core/SuggestionsAggregator";
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

const configuration: IStripingConfiguration[] = [
    {
        clients: ["Homepage", "AWSHomepage"],
        lobs: ["FLIGHTS", "HOTELS", "CARS", "PACKAGES", "ACTIVITIES"],
    },
    {
        clients: ["Hotels.Search", "Flights.Search", "Cars.Search", "LX.Search", "Packages.Search",
            "LXLandingPage", "PackageLandingPage", "FlightsLandingPage", "CarsLandingPage",
            "HotelsLandingPage"],
    },
];

export class ShowEssOnFocusPersonalizedSuggestions implements IFocusSuggester {
    private dataProvider: EssDataProvider = new EssDataProvider();

    public getId(): SuggesterId {
        return SuggesterId.EssOnFocusPersonalizedSuggester;
    }

    public suggest(options: any, context: IContext): JQueryPromise<ISuggesterResponse> {
        const deferred: JQueryDeferred<ISuggesterResponse> = $.Deferred();
        if (ExecutionHelper.shouldExecute(context, configuration)) {
            this.fetchSuggestionsAndResolve(deferred, options, context);
        } else {
            this.resolve(deferred, [], "", "", "", "");
        }
        return deferred.promise();
    }

    public suggestOnFocus(options: any, context: IContext) {
        return this.suggest(options, context);
    }

    private resolve(deferred: JQueryDeferred<ISuggesterResponse>, suggestions: IListItem[], activeABTests: string,
                    overriddenABTests: string, requestId: string, metadata: string): void {
        deferred.resolve({
            activeABTests,
            id: this.getId(),
            metadata,
            overriddenABTests,
            requestId,
            results: suggestions,
        });
    }

    private fetchSuggestionsAndResolve(
        deferred: JQueryDeferred<ISuggesterResponse>,
        options: any,
        context: IContext): void {

        let suggestions: IListItem[] = [];
        let activeABTests: string = "";
        let overriddenABTests: string = "";
        let requestId: string = "";
        let metadata: string = "";

        this.dataProvider
            .fetchData($.extend(true, {}, options, {context}, {personalize: true}))
            .then((response: IEssResponse) => {
                if (response) {
                    if (response.results) {
                        suggestions = suggestions.concat(response.results);
                    }
                    if (response.activeABTests) {
                        activeABTests = response.activeABTests;
                    }
                    if (response.overriddenABTests) {
                        overriddenABTests = response.overriddenABTests;
                    }
                    if (response.requestId) {
                       requestId = response.requestId;
                    }
                    if (response.metadata) {
                        metadata = response.metadata;
                    }
                }
            })
            .fail((error) => {
                TypeaheadUtils.logError(error, "", abTest);
            })
            .always(() => {
                this.resolve(deferred, suggestions, activeABTests, overriddenABTests, requestId, metadata);
            });
    }
}
